<div *ngIf="shared.isLoader" class="loader-div">
    <div class="loader"></div>
</div>